export const BAND_QUESTS_ANCHOR_ID = 'band-quests';

const POLL_INTERVAL_MS = 100;
const GIVE_UP_AFTER_MS = 2_000;

export function scrollToBandQuests(): void {
  if (typeof document === 'undefined') return;

  const deadline = Date.now() + GIVE_UP_AFTER_MS;
  const tick = () => {
    const target = document.getElementById(BAND_QUESTS_ANCHOR_ID);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (Date.now() < deadline) {
      setTimeout(tick, POLL_INTERVAL_MS);
    }
  };
  tick();
}
